// extracted by mini-css-extract-plugin
export var actionButton = "_rr-0";
export var actionMenuContainer = "_rr-i";
export var bubble = "_rr-2";
export var bubbleActionMenu = "_rr-j";
export var bubbleContext = "_rr-6";
export var bubbleItems = "_rr-7";
export var customer = "_rr-3";
export var divider = "_rr-8";
export var fileList = "_rr-9";
export var hiddenComment = "_rr-o";
export var infoAbove = "_rr-a";
export var internal = "_rr-4";
export var lightActionButton = "_rr-1";
export var link = "_rr-b";
export var merchant = "_rr-5";
export var message = "_rr-c";
export var profilePicture = "_rr-e";
export var quillToolbarContainer = "_rr-f";
export var senderDate = "_rr-g";
export var senderDateCustomer = "_rr-h";
export var senderName = "_rr-d";
export var time = "_rr-k";
export var uploadedImage = "_rr-l";
export var username = "_rr-m";
export var xsmall = "_rr-n";